import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { useState, useEffect } from "react";
import axios from "axios";
import { errorToast, successToast } from "../../common/ToastMessage";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function VendorsEditModal({
  vendoresId,
  vendorsdata,
  open,
  close,
  getvendor,
  setLoaderActive
}) {
  const [error, setError] = useState([]);
  const numberPattern = new RegExp(/^[0-9{10}\b]+$/);
  const [suppliername, setSupplierName] = useState("");
  const [suppliernumber, setSupplierNumber] = useState("");
  const [suppliertype, setSupplierType] = useState("");
  const [supplieraddress, setSupplierAddress] = useState("");

  useEffect(() => {
    setSupplierName(vendorsdata.supplierName);
    setSupplierNumber(vendorsdata.supplierNumber);
    setSupplierType(vendorsdata.supplierType);
    setSupplierAddress(vendorsdata.supplierAddress);
  }, [vendorsdata]);

  const resetField = () => {
    setError([]); 
    setSupplierName('');
    setSupplierNumber('')
    setSupplierType('')
    setSupplierAddress('')
  }

  function editVendorsData() {
    if (validateForm()) {
      setLoaderActive(true)
      let item = {
        supplierId: vendoresId,
        suppliername: suppliername,
        suppliernumber: suppliernumber,
        suppliertype: suppliertype,
        supplieraddress: supplieraddress,
      };

      const headers = {
        Authorization: "Bearer " + localStorage.getItem("_token"),
        "Content-type": "application/json",
      };

      axios
        .post(
          `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Vendor/Update`,
          item,
          {
            headers: headers,
          }
        )
        .then(function (response) {
          setLoaderActive(false)
          if (response?.status == "200") {
            close();
            resetField();
            getvendor();
            successToast(response?.data?.message)
          }
        })
        .catch(function (error) {
          console.log("error", error);
          setLoaderActive(false)
          if (error?.response?.status === 401) {
            errorToast(error?.response?.statusText)
          } else {
          errorToast(error?.message)
        }
        });
    }
  }
  const validateForm = () => {
    setError([]);
    let error = {};
    let onlyAlphaChar = "Please enter only number.";
    let num = "Please enter 10 digit number.";
    if (!suppliername) {
      error.suppliername = "Supplier name is required";
    }
    if (!suppliernumber) {
      error.suppliernumber = "Supplier number is required";
    }
    if (suppliernumber && !numberPattern.test(suppliernumber)) {
      error.suppliernumber = onlyAlphaChar;
    }
    if (suppliernumber.length != "10") {
      error.suppliernumber = num;
    }
    if (!suppliertype) {
      error.suppliertype = "Supplier type is required";
    }
    if (!supplieraddress) {
      error.supplieraddress = "Supplier address is required";
    }
    if (Object.keys(error).length > 0) {
      setError(error);
      return false;
    }
    return true;
  };
  return (
    <div>
      {open ? (
        <BootstrapDialog
          className="supplier-modal-wrap modal-wrap"
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={() => {resetField(); close()}}
          >
            Edit Vendor
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <div className="row">
              <div className="col-md-12">
                <TextField
                  hidden
                  value={vendorsdata.supplierId ? vendorsdata.supplierId : ""}
                />
              </div>
              <div className="col-md-12">
                <div className="txtfield-wrap">
                  <TextField
                    error={error && error.suppliername}
                    id="outlined-required"
                    fullWidth
                    label="Vendor Name"
                    value={suppliername ? suppliername : ""}
                    onChange={(e) => setSupplierName(e.target.value)}
                    helperText={error.suppliername}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="txtfield-wrap">
                  <TextField
                    error={error && error.suppliernumber}
                    fullWidth
                    id="outlined-required"
                    label="Vendor Conatact Number"
                    value={suppliernumber ? suppliernumber : ""}
                    onChange={(e) => setSupplierNumber(e.target.value)}
                    helperText={error.suppliernumber}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="txtfield-wrap">
                  <TextField
                    error={error && error.suppliertype}
                    fullWidth
                    id="outlined-required"
                    label="Vendor Type"
                    value={suppliertype ? suppliertype : ""}
                    onChange={(e) => setSupplierType(e.target.value)}
                    helperText={error.suppliertype}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="txtfield-wrap">
                  <TextField
                    error={error && error.supplieraddress}
                    fullWidth
                    id="outlined-required"
                    label="Vendor Address"
                    value={supplieraddress ? supplieraddress : ""}
                    onChange={(e) => setSupplierAddress(e.target.value)}
                    helperText={error.supplieraddress}
                  />
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions className="btns-wrapper">
            <Stack spacing={4} direction="row" className="bottom-btn-wrap">
              <Button onClick={editVendorsData} variant="outlined">
                Update
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  resetField(); close();
                }}
              >
                Cancel
              </Button>
            </Stack>
          </DialogActions>
        </BootstrapDialog>
      ) : null}
    </div>
  );
}
